export { default } from './CamError';
